import { PermissionTypes } from 'redux/Auth/auth.state'

export const permissionLabels: Record<keyof PermissionTypes, string> = {
  read: 'Read',
  write: 'Write',
  delete: 'Delete',
  canViewUserData: 'User Info',
  canViewPaymentData: 'Payment Info',
}
